import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ProximitySettingsContainer } from './proximitySettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ProximitySettings: undefined;
  }
}

modalRenderer.register('ProximitySettings', ProximitySettingsContainer);
